<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        classTabContent="pl-12 pr-12"
                        class="mt-3"
                        :data="tabData"
                        activeKey="expired_jobs">
                    <template slot="gofixTab:expired_jobs">
                        <gofix-card class="mb-0" fullContent>
                            <jobs job_status="Expired"></jobs>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    const jobs = () => import("./jobs")
    export default {
        name: 'joblist-all',
        components: {
            jobs
        },
        data() {
            return{
                tabData:[
                    {
                        key: "due_jobs",
                        title: "DUE JOBS",
                        active: false,
                        link: `/v2/job-list/due`
                    },
                    {
                        key: "completed_jobs",
                        title: "COMPLETED JOBS",
                        active: false,
                        link: `/v2/job-list/completed`
                    },
                    {
                        key: "expired_jobs",
                        title: "EXPIRED JOBS",
                        active: true,
                        link: `/v2/job-list/expired`
                    },
                    {
                        key: "all_jobs",
                        title: "ALL",
                        active: false,
                        link: `/v2/job-list`
                    },
                ]
            }
        },
        created() {},
        methods: {}
    }
</script>
